import React from "react";
import Navbar from "./components/navbar";
import CreateComponent from "./create/create.component";
import CreateProvider from "./create/provider/create.provider";
import CreateUsedProvider from "./create/used/provider/createUsed.provider";
import CreateNewsProvider from "./create/news/provider/createNews.provider";
import LogoAcinco from "../../assets/images/logo_acinco_white.png";

const CredicelexpressPage = () => {
  return (
    <CreateProvider>
      <CreateNewsProvider>
        <CreateUsedProvider>
          <div className="flex h-screen flex-col overflow-auto bg-gradient-to-b from-[#d5c08a] to-[#ffffff]">
            <Navbar />
            <section className="z-10 flex h-full w-full items-center justify-center p-0">
              <div className="container mb-auto mt-auto w-full px-4 lg:px-20">
                <CreateComponent />
              </div>
            </section>
            <div className="absolute bottom-0 mb-4 flex w-full items-center justify-center text-white">
              Respaldado por{"   "}
              <img
                src={LogoAcinco}
                alt="logo_acinco"
                className="ml-2 max-h-14"
              />
            </div>
          </div>
        </CreateUsedProvider>
      </CreateNewsProvider>
    </CreateProvider>
  );
};

export default CredicelexpressPage;
